import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import {
  BaseIntegrationDto,
  GoogleGlobalSettingsDto,
  RechargeGlobalSettingsDto,
  StayAiInternalSettingsDto,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { useGetIntegration } from "../../../api/integrations/use-integration";
import { SetupGoogleIntegration } from "../../../components/Google/SetupGoogleIntegration";
import Loading from "../../../utils/Loading";

import { AmpedIntegration } from "./Amped/AmpedIntegration";
import { ClarityIntegration } from "./Clarity/ClarityIntegration";
import { CustomApiIntegration } from "./CustomApi/CustomApiIntegration";
import { HeatmapIntegration } from "./Heatmap/HeatmapIntegration";
import { HotjarIntegration } from "./Hotjar/HotjarIntegration";
import { RechargeIntegration } from "./Recharge/RechargeIntegration";
import { StayAiIntegration } from "./StayAi/StayAiIntegration";

const Title = ({ title }: { title: string }) => {
  return (
    <Grid item sx={{ marginBottom: "-10px" }}>
      <IgTypography sx={{ fontWeight: 600, fontSize: "22px" }}>
        {title}
      </IgTypography>
    </Grid>
  );
};

export const IntegrationsRoute = () => {
  const googleIntegration =
    useGetIntegration<BaseIntegrationDto<GoogleGlobalSettingsDto>>("Google");

  const rechargeIntegration =
    useGetIntegration<BaseIntegrationDto<RechargeGlobalSettingsDto>>(
      "Recharge"
    );
  const stayAiIntegration =
    useGetIntegration<BaseIntegrationDto<any, StayAiInternalSettingsDto>>(
      "StayAi"
    );

  const ampedIntegration = useGetIntegration<BaseIntegrationDto>("Amped");
  const customApiIntegration =
    useGetIntegration<BaseIntegrationDto>("CustomApi");

  const clarityIntegration = useGetIntegration<BaseIntegrationDto>("Clarity");
  const heatmapIntegration = useGetIntegration<BaseIntegrationDto>("Heatmap");
  const hotjarIntegration = useGetIntegration<BaseIntegrationDto>("Hotjar");

  if (
    googleIntegration.isSuccess &&
    rechargeIntegration.isSuccess &&
    ampedIntegration.isSuccess &&
    clarityIntegration.isSuccess &&
    heatmapIntegration.isSuccess &&
    customApiIntegration.isSuccess &&
    stayAiIntegration.isSuccess
  ) {
    return (
      <Grid container direction={"column"} rowSpacing={2}>
        <Grid item xs>
          <IgTypography variant="h5">Third-Party Integrations</IgTypography>
        </Grid>
        <Title title={"Analytics"} />
        <Grid item>
          <SetupGoogleIntegration
            googleIntegration={googleIntegration.data || undefined}
          />
        </Grid>
        <Grid item>
          <ClarityIntegration
            clarityIntegration={clarityIntegration.data || undefined}
          />
        </Grid>
        <Grid item>
          <HeatmapIntegration
            heatmapIntegration={heatmapIntegration.data || undefined}
          />
        </Grid>
        <Grid item>
          <HotjarIntegration
            hotjarIntegration={hotjarIntegration.data || undefined}
          />
        </Grid>
        <Title title={"Subscription Apps"} />
        <Grid item>
          <RechargeIntegration
            rechargeIntegration={rechargeIntegration.data || undefined}
          />
        </Grid>
        <Grid item>
          <StayAiIntegration
            stayAiIntegration={stayAiIntegration.data || undefined}
          />
        </Grid>
        <Title title={"On-site Apps"} />
        <Grid item>
          <AmpedIntegration
            ampedIntegration={ampedIntegration.data || undefined}
          />
        </Grid>
        <Title title={"API Access"} />
        <Grid item>
          <CustomApiIntegration
            customApiIntegration={customApiIntegration.data || undefined}
          />
        </Grid>
      </Grid>
    );
  }
  return <Loading />;
};
